import gql from "graphql-tag";

export const MY_CAFETERIA_GET_MENU = gql`
  query getCafeteriaMenu($contractCode: String!) {
    getCafeteriaMenu(contractCode: $contractCode) {
      code
      name
      isPeriodical
      isReusable
      availableMonths
      startDate
      endDate
      planable
      isSZEPCardItem
      isSZEPActiveHungariansCardItem
    }
  }
`;

export default MY_CAFETERIA_GET_MENU;
